import { Injectable } from '@angular/core';
import { AlarmeService } from '../../_services/http/alarme.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  loadAlarmesAction,
  loadAlarmesSuccessAction,
  getIsAlarmeInitialized,
  AlarmeState,
  loadAlarmesErrorAction,
} from './alarme.store';
import {
  catchError,
  filter,
  map,
  mergeMap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';
import { Store } from '@ngrx/store';

@Injectable()
export class AlarmeEffect {
  constructor(
    private service: AlarmeService,
    private actions$: Actions,
    private store: Store<AlarmeState>
  ) {}

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadAlarmesAction),
      withLatestFrom(this.store.select(getIsAlarmeInitialized)),
      filter(([action, isInitialized]) => !isInitialized),
      mergeMap(() =>
        this.service.all().pipe(
          map((payload) => loadAlarmesSuccessAction({ payload })),
          catchError(() => of(loadAlarmesErrorAction()))
        )
      )
    )
  );
}
